import { render, staticRenderFns } from "./DetailCreateTable.vue?vue&type=template&id=28560b64&scoped=true"
import script from "./DetailCreateTable.vue?vue&type=script&lang=js"
export * from "./DetailCreateTable.vue?vue&type=script&lang=js"
import style0 from "./DetailCreateTable.vue?vue&type=style&index=0&id=28560b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28560b64",
  null
  
)

export default component.exports